import React from 'react';
import { SingleHeadline } from './SingleHeadline';
import { observer } from 'src/utils/mobx-react';
import { HeadlineCarouselDataState } from 'src/AppState/CmsState/HeadlineCarouselDataState/HeadlineCarouselData.state';
import { HeadlineCarouselModelType } from 'src/api/config/headlineCarousel/getHeadlineCarousel';
import { ListContainer, ErrorMessageTop } from 'src/domains/layouts/shared/cms/list/List.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

interface PropsTypes {
    headlineCarouselsData: HeadlineCarouselDataState;
}

export const HeadlineCarouselList = observer('HeadlineCarouselList', ({headlineCarouselsData}: PropsTypes): JSX.Element => {

    const { errorMessageForList, isLoading, headlineCarousels } = headlineCarouselsData;
    return (
        <>
            {errorMessageForList !== null && <ErrorMessageTop>{errorMessageForList}</ErrorMessageTop>}

            <ListContainer areLoading={isLoading}>
                <Loader isActive={isLoading} />

                {headlineCarousels.map((headlineCarousel: HeadlineCarouselModelType) => (
                    <SingleHeadline key={headlineCarousel.id} headlineCarouselsData={headlineCarouselsData} headlineCarousel={headlineCarousel}/>
                ))}
            </ListContainer>
        </>
    );
});
